import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import {Link} from "react-router-dom";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";
import Icon from "../../../../components/selfcare/Icon.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";

const questions: Question[] = [
    {
        question: "Fiber",
        answer: <>
            <p>
                Du kan enten forbinde dit udstyr direkte til fiberboksen eller gennem vores router.
            </p>
            <p>
                Vil du sætte dit udstyr direkte til fiberboksen?
                Følg guiden til VLAN-tagging nedenunder.
            </p>
            <div className={'button-container'}>
                <Link className={'button button--montserrat with-icon teal'} to={'/hjaelp/udstyr/vlan-tagging'}>
                    <span className={'text'}>Guide til VLAN-tagging</span>
                    <Icon component={IconArrow}/>
                </Link>
            </div>
            <p>
                Vil du bruge udstyret gennem vores router?
                Følg guiden til at sætte din router i bridge mode nedenunder.
            </p>
            <div className={'button-container'}>
                <Link className={'button button--montserrat with-icon teal'} to={'/hjaelp/udstyr/bridge-mode'}>
                    <span className={'text'}>Guide til bridge mode</span>
                    <Icon component={IconArrow}/>
                </Link>
            </div>
        </>
    },
    /*{
        question: "5G-internet",
        answer: <>
            <p>
                Hvis du vil bruge din egen router, skal du sætte den i forlængelse af vores router (dvs. sætte din egen router i bridge mode).
                Følg guiden nedenunder.
            </p>
            <div className={'button-container'}>
                <Link className={'button button--montserrat with-icon teal'} to={'/hjaelp/udstyr/bridge-mode'}>
                    <span className={'text'}>Guide til bridge mode</span>
                    <Icon component={IconArrow}/>
                </Link>
            </div>
        </>
    },*/
    {
        question: "Kabel-tv-stik",
        answer: <>
            <p>
                Hvis du vil bruge din egen router, skal du sætte den i forlængelse af routeren, du har fået fra os.
                Routeren fra os skal nemlig sidde i kabel-tv-stikket eller telefonstikket på din væg, afhængig af hvilken forbindelse du har.
            </p>
            <p>
                Sæt din egen router til vores router og følg bridge mode guiden nedenunder.
            </p>
            <div className={'button-container'}>
                <Link className={'button button--montserrat with-icon teal'} to={'/hjaelp/udstyr/bridge-mode'}>
                    <span className={'text'}>Guide til bridge mode</span>
                    <Icon component={IconArrow}/>
                </Link>
            </div>
        </>
    }
];

export default function EgenRouterArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Ja, det kan du sagtens!
                            Du kan bruge din egen router, forstærker, access point, powerline eller mesh-system.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Vil du bruge et access point, powerline eller forstærker?</h2>
                        <p>
                            Så skal du installere den ved hjælp af manualen, som fulgte med, da du købte den.
                            Vi supporterer desværre ikke opsætning af de tre typer.
                        </p>
                    </div>
                </div>

                <div className="article article--connect">
                    <div className="paragraph">
                        <h2>Vil du bruge din egen router eller mesh?</h2>
                        <p>
                            Opsætningen afhænger af, om du har fibernet, internet gennem telefonstikket eller gennem dit kabel-tv-stik.
                            Vælg din forbindelse herunder:
                        </p>
                    </div>
                </div>

                <div className="article">
                    <QuestionAnswerComponent questions={[...questions, WhatConnectionType]}/>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad skal jeg være opmærksom på, når jeg bruger mit eget udstyr?</h2>
                        <p>
                            Der kan være forskellige flaskehalse, der kan påvirke hastigheden på dit wif og flere fejlkilder kan spille en rolle for, om du får den rigtige hastighed.
                            F.eks. er det ikke alle routere, switches, extenders, access points mm. der kan trække 1000 mbit.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Typiske fejlkilder</h2>
                        <ul className="list list--bullet list--compact">
                            <li>
                                <p>Internetkabler</p>
                            </li>
                            <li>
                                <p>Netværkskort</p>
                            </li>
                            <li>
                                <p>Hastighedsbegrænsning på udstyret</p>
                            </li>
                        </ul>
                        <p>
                            Vi kan ikke yde support på eget udstyr.
                            Hvis du oplever udfordringer på hastigheden ved brug af eget udstyr, så anbefaler vi at du sætter din Hiper router til og tester direkte på det.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "ip-adresse",
                        "name": "IP-adresse"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "udstyr",
                        "article": "installationsmanual",
                        "name": "Hvordan installerer jeg min router?"
                    }
                ]}
            />
        </>
    )
}
